// src/components/cards/BaseExpandedCard.jsx
import React from 'react';
import { Modal, Box, IconButton, Typography, Tooltip, Fade } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';

const BaseExpandedCard = ({
  open,
  onClose,
  title,
  subtitle,
  headerMeta,
  onAddToLayout,
  children
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            width: '90%',
            maxWidth: 1200,
            height: '90vh',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* Header — pinned */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            p: 2,
            borderBottom: '1px solid rgba(255,255,255,0.1)',
            flexShrink: 0,
          }}>
            <IconButton onClick={onClose} sx={{ mr: 2 }}>
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <Typography variant="h5">
                {title || 'Expanded View'}
              </Typography>
              {subtitle && (
                <Typography variant="subtitle2" color="text.secondary">
                  {subtitle}
                </Typography>
              )}
              {headerMeta && (
                <Box sx={{ mt: 0.5 }}>
                  {headerMeta}
                </Box>
              )}
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            {onAddToLayout && (
              <Tooltip title="Pin to workspace">
                <IconButton
                  onClick={(e) => { e.stopPropagation(); onAddToLayout(); }}
                  size="small"
                  sx={{ mr: 0.5, color: 'text.secondary', '&:hover': { color: '#BB86FC' } }}
                >
                  <PushPinOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content area — scrollable */}
          <Box sx={{ p: 2, flex: 1, overflowY: 'auto' }}>
            {children}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default BaseExpandedCard;

